import { Text } from "@dropbox/dig-components/typography";
import { useDocumentFollowUpSuggestions } from "@mirage/mosaics/QuerySuggestions/useDocumentFollowUpSuggestions";
import { SuggestionTile } from "@mirage/mosaics/SuggestionTile/SuggestionTile";
import { useTranslation } from "react-i18next";
import styles from "./FollowUpChips.module.css";

import type { DocumentFollowUpSuggestion } from "@mirage/mosaics/QuerySuggestions/useDocumentFollowUpSuggestions";
import type { SearchResult } from "@mirage/service-dbx-api";

type FollowUpChipsProps = {
  result: SearchResult;
  onSuggestionClick: (suggestion: DocumentFollowUpSuggestion) => void;
};

export function FollowUpChips({
  result,
  onSuggestionClick,
}: FollowUpChipsProps) {
  const { t } = useTranslation();
  const { suggestions, isLoading } = useDocumentFollowUpSuggestions(result);

  if (!isLoading && suggestions.length === 0) {
    return null;
  }

  return (
    <div className={styles.followUpSection}>
      <div className={styles.sectionHeader}>
        <Text size="medium" isBold className={styles.sectionTitle}>
          {t("follow_up_label")}
        </Text>
      </div>

      <div className={styles.followUpChips}>
        {suggestions.map((suggestion, index) => (
          <SuggestionTile
            key={suggestion.id || `loading_${index}`}
            text={suggestion.text || "Loading..."}
            size="small"
            display="inline"
            isLoading={!suggestion.text}
            onClick={
              suggestion.text ? () => onSuggestionClick(suggestion) : () => {}
            }
            withNoBackground
          />
        ))}
      </div>
    </div>
  );
}
